/**
 * User's preferred currency from Account > Preferences.
 * Stored in localStorage under accountPreferences.currency.
 */

const STORAGE_KEY = 'accountPreferences';
const DEFAULT_CURRENCY = 'INR';

const CURRENCY_SYMBOLS = {
  INR: '₹',
  USD: '$',
  EUR: '€',
  GBP: '£'
};

/**
 * Get the user's preferred currency code (INR, USD, EUR, GBP).
 */
export function getPreferredCurrency() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const prefs = JSON.parse(stored);
      const code = prefs.currency;
      if (code && ['INR', 'USD', 'EUR', 'GBP'].includes(code)) return code;
    }
  } catch (e) {}
  return DEFAULT_CURRENCY;
}

/**
 * Get currency symbol for the preferred or given currency.
 */
export function getCurrencySymbol(currency) {
  return CURRENCY_SYMBOLS[currency || getPreferredCurrency()] || CURRENCY_SYMBOLS.INR;
}

/**
 * Format a price amount using the user's preferred currency (or optional override).
 * Uses Intl.NumberFormat when available for proper locale formatting.
 */
export function formatPrice(amount, currency) {
  const code = currency || getPreferredCurrency();
  if (amount == null || Number.isNaN(Number(amount))) return '—';
  const num = Number(amount);
  try {
    const locale = code === 'INR' ? 'en-IN' : 'en-US';
    return new Intl.NumberFormat(locale, { style: 'currency', currency: code, maximumFractionDigits: 0 }).format(num);
  } catch (e) {
    const symbol = getCurrencySymbol(code);
    return `${symbol}${num.toLocaleString()}`;
  }
}
